<template>
    <div class="header headerrem">
        <div class="Loading__bar___21yOt">
        </div>
        <el-row>
            <el-col :span="15">
                <div class="logo">
                    <span>{{b_name}}</span>
                </div>
            </el-col>
            <el-col :span="6" class="text_right">
                <div>
                    <div class="backSuper school-info ">
                        <span>{{ps_name}}</span>
                    </div>
                    &nbsp;
                    <div class="backSuper school-info changepassword"  @click="onChangePassword">
                        <span>{{username}}</span>
                    </div>
                </div>
            </el-col>
            <el-col v-if="is_Super"   :span="1" class="h30">
                <el-button
                        type="primary"
                        plain
                        size="mini"
                        @click="backSuper"
                        class="backSuper col_df"
                >返回登陆
                </el-button>
            </el-col>
            <el-col :span="2">
                <div class="user-info">
                    <!-- <b class="fgx">丨</b> -->
                    <div
                            class="el-dropdown-link"
                            @click="handleCommand"
                    >
                        <!--<div class="navbar-right"></div>-->
                        <span class="tc el-icon-switch-button">退出</span>
                    </div>
                    <!-- <el-dropdown-menu class="exit" slot="dropdown">
                          <div></div>
                          <el-dropdown-item command="loginout">退出</el-dropdown-item>
                        </el-dropdown-menu> -->
                </div>
            </el-col>
        </el-row>
        <el-dialog
                title="错误信息"
                :visible.sync="dialogerror"
                width="50%"
        >
            <el-table
                    :data="tableData"
                    stripe
                    style="width:100%">
                <el-table-column
                        prop="field"
                        label="字段"
                       >
                </el-table-column>
                <el-table-column
                        prop="name"
                        label="描述"
                        >
                </el-table-column>
                <el-table-column
                        prop="example"
                        label="实例"
                >
                </el-table-column>
            </el-table>
        </el-dialog>
        <el-dialog width="30%" title="修改密码" :modal="true" @close="handleChangePwdCancel" :visible.sync="editPasswordShow"
                   class="close1">
            <el-form label-width="120px" size="mini">
                <el-form-item label="新密码:">
                    <el-input v-model="editPasswordForm.newPassword1"></el-input>
                </el-form-item>
                <el-form-item label="再次输入新密码:">
                    <el-input v-model="editPasswordForm.newPassword2"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button size="mini" @click="handleChangePwdCancel">取 消</el-button>
                <el-button size="mini" type="primary" @click="handleEditPassword()">确 定</el-button>
            </div>
        </el-dialog>
    </div>

</template>

<script>
    import {mapMutations} from "vuex";

    export default {
        data() {
            return {
                initUsername: "游客登录",
                editPasswordShow:false,
                editPasswordForm: {newPassword1: "", newPassword2: "", loginType:1},
                dialogerror:false,
                tableData:[
                    {field:'brandStory',name:'品牌故事',example:'brandStory: 与schema定义的STRING格式不相符'},
                    {field:'serviceScope',name:'服务内容',example:'serviceScope: 与schema定义的长度不相符'},
                    {field:'advantage',name:'服务优势',example:'advantage: 与schema定义的小于等于规则不相符'},
                    {field:'course_content',name:'课程内容',example:'course_content: 是否必填参数规则配置错误'},
                    {field:'category',name:'类目',example:'category: 与schema定义的有效值规则不相符'},
                    {field:'Service temporarily unavailable',name:'服务暂时不可用',example:'Service temporarily unavailable'},
                ],
            };
        },
        computed: {
            username() {
                let myUsername = localStorage.getItem("org_user_name"); // 对象  没有是为null
                return myUsername !== null ? myUsername : this.initUsername;
            },
            ps_name() {
                let myUsername = localStorage.getItem("org_ps_name"); // 对象  没有是为null
                return myUsername !== null ? myUsername : '';
            },
            school_name() {
                let myUsername = localStorage.getItem("org_school_name"); // 对象  没有是为null
                return myUsername !== null ? myUsername : '';
            },
            b_name() {
                let myUsername = localStorage.getItem("org_b_name"); // 对象  没有是为null
                return myUsername !== null ? myUsername : '';
            },
            is_Super() {
                let isSuper = localStorage.getItem("is_Super"); // 对象  没有是为null
                if (isSuper !== null && isSuper == "true") {
                    return true;
                } else {
                    return false;
                }
            }
        },
        methods: {
            backSuper() {
                let that = this;
                this.$ajax.get("admin/User/super_login").then(function (res) {
                    if (res.data.error === 1) {
                        that.$message.error(res.data.msg);
                    } else {
                        localStorage.setItem("org_user_name", res.data.msg.user_name);
                        localStorage.setItem("org_ps_name", res.data.msg.ps_name);
                        localStorage.setItem("is_Super", false);
                        that.$router.go(0);
                    }
                });
            },
            handleCommand() {
                localStorage.removeItem("org_user_name");
                this.$ajax.get("/admin/Login/logout");
                this.$router.push("/");
            },
            ...mapMutations("navTabs", [
                // 下拉框选择所有已打开的标签
                "freshTabFunc"
            ]),
            ...mapMutations("navTabs", [
                // 下拉框选择所有已打开的标签
                "closeAllTabFunc"
            ]),
            onChangePassword() {
                this.editPasswordShow = true;
            },
            handleChangePwdCancel()
            {
                this.editPasswordShow = false;
            },
            handleEditPassword() {
                let that = this;
                this.$ajax
                    .post("admin/User/editPwd", this.editPasswordForm)
                    .then(function (res) {
                        if (res.data.error === 0) {
                            that.$message({
                                type: "success",
                                message: "修改成功!"
                            });
                            that.editPasswordShow = false;
                        } else {
                            that.$message(res.data.message);
                        }
                    });
            },
            errorData(){
                this.dialogerror=true;
            }
        }
    };
</script>
<style>
    .headerrem .navbar-right {
        width: 20px;
        height: 20px;
        margin: 4px 0 0 8px;
        vertical-align: middle;
        background: url(../../../assets/img/tc.png) no-repeat center center;
    }
    .headerrem .el-icon-switch-button{
        line-height: unset;
    }
    .headerrem .changepassword{
        cursor: pointer;
    }
    .headerrem .Loading__bar___21yOt{
        background: rgb(33, 186, 69);
        width: 0%;
        height:2px;
        transition: width .35s;
        position: fixed;top:0
    }
    .headerrem .logo>span{
        margin-left: 5px
    }
    .headerrem .el-dialog{
        min-width: 300px;
        box-shadow:none;
    }
</style>



// WEBPACK FOOTER //
// src/views/admin/home/Header.vue